<template>
  <div class="content">
    <div v-if="isLoading">
      <div v-for="index in 5" :key="index" class="mb-16">
        <CardShimmer data-testid="trx-shimmer-card" />
      </div>
    </div>
    <div v-else-if="transactionList.length > 0">
      <div v-for="(trx, idx) in transactionList" :key="idx" class="mb-16">
        <PrakerjaItem :id="trx.id" data-testid="trx-card" :name="trx.name" :merchant-name="trx.merchant.name" :course-img="trx.image.url" />
      </div>
    </div>
    <EmptyTransaction v-else data-testid="empty-trx" />
  </div>
</template>

<script>
import PrakerjaItem from '../molecules/transaction/PrakerjaItem.vue';
import CardShimmer from '../molecules/transaction/CardShimmer.vue';
import EmptyTransaction from './EmptyTransaction.vue';

export default {
  name: 'PrakerjaTransactionList',
  components: {
    PrakerjaItem,
    CardShimmer,
    EmptyTransaction,
  },
  data() {
    return {
      isLoading: false,
      transactionList: [],
      activeTabName: 'prakerja',
      tabs: ['prakerja', 'edukarier'],
    };
  },
  computed: {
    isLogin() {
      return window.USER.id !== '' && window.USER.id !== null;
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    onClickBack() {
      this.$router.go(-1);
    },
    async init() {
      this.isLoading = true;
      this.$api
        .getPrakerjaTransactions({
          offset: 0,
          limit: 10,
          type: 'prakerja',
          state: 'succeeded',
        })
        .then(({data}) => {
          this.transactionList = data;
        })
        .catch(() => {
          this.transactionList = [];
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  min-height: calc(100vh - 97px);
  padding: 16px;
}
</style>
